// ignore-string-externalization

import { useCallback, useEffect } from 'react';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { ModuleType } from '../Module/types';
import { defaultTheme } from '../Theme';
import { useLayoutContext } from '../Layout';

export const useDynamicNavBarColor = (
  module?: Partial<ModuleType>,
  isNavBarFullBleed = true,
) => {
  const { setNavBarBackground, setNavBarTextColor, setNavBarBleed } =
    useLayoutContext();

  const updateNavBar = useCallback(
    (mod?: Partial<ModuleType>) => {
      setNavBarBackground(mod?.backgroundColor || defaultTheme.nav.background);
      setNavBarTextColor(mod?.textColor || defaultTheme.nav.text);
    },
    [setNavBarTextColor, setNavBarBackground],
  );

  useEffect(() => {
    if (isNavBarFullBleed) {
      setNavBarBleed(true);
      updateNavBar(module);
    } else {
      setNavBarBleed(false);
    }

    return () => {
      setNavBarBleed(false);
    };
  }, [module, isNavBarFullBleed, updateNavBar]);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (currPos.y < prevPos.y && prevPos.y === 0) {
        // scrolling down: reset nav bar to default colors
        updateNavBar();
      } else if (currPos.y > prevPos.y && currPos.y === 0) {
        // scrolling return to 0: reset nav bar colors to first module
        updateNavBar(module);
      }
    },
    [module],
  );
};
